import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { CustomHttpClientService } from './custom-http-client.service';
declare var $: any;
import { Observable, throwError } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
@Injectable()
export class HttpService {
  private data: Object;
  private url = environment.apiUrl;
  jwt = new JwtHelperService();
  // constructor(private http: Http, private store: Store<any>,
  //             private route: ActivatedRoute){}

  constructor(private http: CustomHttpClientService, private _http: HttpClient, private route: ActivatedRoute) { }

  submitEnterpriseContact(values: any): Observable<any> {
    return this._http.post<any>(this.url + 'contact/enterprise', values);
  }

  submitContact(values: any): Observable<any> {
    return this._http.post(this.url + 'contact/contact', values);
  }
  getCountries(): Observable<any> {
    return this._http.get(this.url + 'auth/getCountries');

  }
  getlatlng(address: any): Observable<any> {
    return this.http.get<any>('https://maps.googleapis.com/maps/api/geocode/json?address=' + address + '&key=AIzaSyA1f_Pr19BEUna0vBqFyIXynRH4Exxlo2c');
  }


  residentAccountSetup(formValue: any): Observable<any> {
    console.log('formValue : ', formValue);
    return this._http.post<any>(this.url + 'auth/residentAccountSetup', formValue)
      .pipe(
        catchError(this.handleError)
      );
  }
  residentSignup(formValue: any): Observable<any> {
    console.log('formValue : ', formValue);
    return this._http.post<any>(this.url + 'auth/residentSignup', formValue).pipe(
      catchError(this.handleError)
    );
  }

  isManager(id: any): Observable<any> {
    const Data = JSON.stringify(id);
    const formData: FormData = new FormData;
    formData.append('id', Data);
    return this._http.post<any>(this.url + 'buildingManager/isBuildingManagerExists', formData);
  }

  isManagerExist(id: any): Observable<any> {
    const Data = JSON.stringify(id);
    const formData: FormData = new FormData;
    formData.append('id', Data);
    return this.http.post<any>(this.url + 'buildingManager/isBuildingManager', formData);
  }

  getTermsAndConditions(): Observable<any> {
    return this._http.get<any>(this.url + 'auth/getToc');
  }

  userLogin(formValue: any): Observable<any> {
    return this._http.post<any>(this.url + 'login', formValue);
  }

  getUser(encryptedId: any): Observable<any> {
    return this._http.post<any>(this.url + 'auth/getUserById', { verifyId: encryptedId });
  }

  resendActivationLink(email: any): Observable<any> {
    return this._http.post<any>(this.url + 'auth/resendActivationLink', { email: email },);
  }

  userVerify(encryptedId: any, token: any): Observable<any> {
    return this._http.post<any>(this.url + 'auth/verify', { verifyId: encryptedId, token: token },);
  }

  facebookLogin(): Observable<any> {
    return this._http.get<any>(this.url + 'auth/facebook');
  }

  resetPassword(email: any): Observable<any> {
    console.log(email);
    const formData: FormData = new FormData;
    formData.append('email', email);
    return this._http.post<any>(this.url + 'auth/forgot', formData);
  }
  passwordChange(value: any): Observable<any> {
    const Data = JSON.stringify(value);
    const formData: FormData = new FormData;
    formData.append('password', Data);
    const token = this.route.snapshot.queryParams['reset'];
    formData.append('token', token);
    return this._http.post<any>(this.url + 'auth/newPassword', formData);
  }

  getUsers(id: any): Observable<any> {
    const formData: FormData = new FormData;
    formData.append('id', id);
    return this.http.post<any>(this.url + 'users/residents', formData);
  }

  postActivity(value: any): Observable<any> {
    const Data = JSON.stringify(value);
    const formData = new FormData();
    const building = localStorage.getItem('buildingresidents');
    const id = localStorage.getItem('residents');

    formData.append('building', building || '');
    formData.append('id', id || '');
    formData.append('feedData', Data);
    formData.append('eventImage', (value.file || null));

    return this.http.post<any>(`${this.url}feed/post`, formData).pipe(
      map(res => res), // If needed, transform the response here
      catchError(error => throwError(error)) // Handle errors
    );
  }


  reportAddressToMycoop(formData: any): Observable<any> {
    const url = environment.apiUrl + 'report/address';

    return this._http.post<any>(url, { reportData: formData },);
  }

  // isAuthenticated(): Observable<{}>{
  //     const url = environment.apiUrl + 'auth/isLogged';
  //     return this.http.get(url).map(res=> res.json());
  // }

  isAuthenticated(): Observable<any> {
    return this.http.get<any>(this.url + 'auth/isLogged').pipe(
      map(res => res), // Directly return the response
      catchError(error => {
        console.error('An error occurred:', error);
        return throwError(error); // Handle errors
      })
    );
  }

  isLocalAuthenticated(): boolean {
    let token = localStorage.getItem('token');
    if (token) {
      return token != null && !this.jwt.isTokenExpired(token);
    }
    return false;
  }

  checkPromoCode(promoCode: any): Observable<any> {
    const url = environment.apiUrl + 'promotion/checkpromocode';
    return this._http.post<any>(url, { promocode: promoCode });
  }

  getPromoCode(): Observable<any> {
    return this.http.get<any>(this.url + 'promo');
  }

  updatePromoCode(promoCode: any): Observable<any> {
    console.log('Promocode value check in service', promoCode);
    return this.http.put<any>(this.url + 'promo/', { code: promoCode });
  }

  deletePromoCode(promoId: any): Observable<any> {
    return this.http.delete<any>(this.url + 'promo/' + promoId);
  }

  logout(): Observable<any> {
    const url = environment.apiUrl + 'auth/logout';
    return this.http.post<any>(url, {});
  }

  flagPostById(activityId: any, userId: any): Observable<any> {
    activityId = JSON.stringify(activityId)
    return this.http.put<any>(this.url + 'activity/' + activityId + '/flag/' + userId, {});
  }

  getFlaggedActivityFeedByUserBuilding(buildingIds: any, userId: any): Observable<any> {
    return this.http.post<any>(this.url + 'activity/flagged', { buildingId: buildingIds, userId: userId });
  }

  getFlaggedActivityFeedByBuilding(buildingIds: any): Observable<any> {
    return this.http.post<any>(this.url + 'building/activity/flagged', { buildingId: buildingIds });
  }

  savePromoCode(promo: any): Observable<any> {
    return this.http.post<any>(this.url + 'promo', { code: promo });
  }

  resendActivationLinkById(id: any): Observable<any> {
    return this._http.post<any>(this.url + 'auth/resendActivationLinkById', { id: id },);
  }

  replaceBuildingByRes(buildingDetails: any): Observable<any> {
    return this.http.post<any>(this.url + 'building/replaceBuildingByRes', { replaceBuilding: buildingDetails });
  }
  replaceExistsBuildingByRes(buildingDetails: any): Observable<any> {
    return this.http.post<any>(this.url + 'building/replaceExistsBuildingByRes', {
      replaceExistsBuilding: buildingDetails
    });
  }


  updateDoneTour(userId: any): Observable<any> {
    return this.http.post<any>(this.url + 'auth/updateDoneTour', { id: userId });
  }

  getBuildingCount(): Observable<any> {
    return this._http.get<any>(this.url + 'auth/totalBuildingCount',);

  }
  retrieveToken(id: any) {
    return this._http.get<any>(this.url + 'auth/retrieveToken/' + id,);
  }

  isManagerByUserId(id: any): Observable<any> {

    return this._http.get<any>(this.url + 'buildingManager/isManagerByUserId/' + id);
  }

  findMycoopBuildingByAddress(address: any): Observable<any> {
    return this._http.get<any>(this.url + 'building/findMycoopBuildingByAddress/' + address,);
  }

  getPresignedImageUrl(s3Key: string): Observable<any> {
    return this._http.post<any>(this.url + 'image/presigned-url', { s3Key: s3Key });
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'An unknown error occurred!';
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // The backend returned an unsuccessful response code
      errorMessage = `Server returned code: ${error.status}, error message is: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
